/* eslint-disable */
import state from '~/assets/js/player/store/state';
import reportToHive from './reportToHive';

const { times, liveInfo, creator } = state;

// 上报初始化
var debugReport = {
  tsSuccessNum: 0,
  tsErrorNum: 0
};

var debugTypes = {
  debugReportIndex: 0, // 技术统计上报index
  errorType: [],
  videoFrames: 0,
  videoDuration: 0,
  userFramerate: [],
  stats: [],
  frags: [],
  bufferLens: [],
  userBandWidth: [],
  userCoderate: [],
  catonArray: [], // 卡顿数组
  catonArraySum: [], // 卡顿array次数求和
  isLastStuck: false,
  lastStuckArray: [], // 卡顿20s统计
  stuckTime: 0,
  stuckTimeArray: [],
  catonCnt: 0,
  logCatons: []
};

var debugReportToHive = function() {
  if (!process.client) {
    return {
      init: new Function,
      report: new Function,
      reportPer: new Function
    }
  }

  var videoDom = document.getElementById('liveVideo');
  var init = function() {
    debugReport.tsSuccessRate = 0;
    debugReport.tsSuccessNum = 0;
    debugReport.tsErrorNum = 0;
    debugTypes.userBandWidth = [];
    debugTypes.userCoderate = [];
    debugTypes.userFramerate = [];
    debugTypes.bufferLens = [];
    debugTypes.errorType = [];
    debugTypes.lastStuckArray = [];
    debugTypes.logCatons = [];
    debugTypes.stuckTimeArray = [];
  };

  var report = function() {
    // 直播信息
    debugReport.browser = navigator.userAgent;
    debugReport.siteid = liveInfo.siteid;
    debugReport.platform = liveInfo.platform;
    let cdnSrc = '';
    let cdnHost = '';
    if (liveInfo.video_src) {
      cdnSrc = liveInfo.video_src;
      cdnHost = liveInfo.video_src.match(/(\w+):\/\/([^/:]+)(:\d*)?/)[2];
    }
    debugReport.cdnSrc = cdnSrc;
    debugReport.cdnHost = cdnHost;
    debugReport.wssUrl = liveInfo.ws_url;
    debugReport.clientIp = liveInfo.clientIp;

    // 播放器状态
    debugReport.media = videoDom ? 1 : 0;
    debugReport.paused = videoDom && videoDom.paused ? 1 : 0;
    debugReport.seeking = videoDom && videoDom.seeking ? 1 : 0;
    debugReport.readyState =
      videoDom && videoDom.readyState ? videoDom.readyState : -1;
    debugReport.currentTime = videoDom && videoDom.currentTime;

    debugReport.alive = liveInfo.alive;

    // 时间阶段状态t1-t7
    debugReport.t1 = times.t1;
    debugReport.t2 = times.t2;
    debugReport.t3 = times.t3;
    debugReport.t4 = times.t4;
    debugReport.t5 = times.t5;
    debugReport.t6 = times.t6;
    debugReport.t7 = times.t7;
    debugReport.reportTime = Date.now();

    // 视频质量数据
    var tsSuccessRate = 0;
    if (debugReport.tsSuccessNum + debugReport.tsErrorNum !== 0) {
      tsSuccessRate =
        debugReport.tsSuccessNum /
        (debugReport.tsSuccessNum + debugReport.tsErrorNum);
    }
    debugReport.tsSuccessRate = tsSuccessRate;
    debugReport.userBandWidth = JSON.stringify(debugTypes.userBandWidth);
    debugReport.userCoderate = JSON.stringify(debugTypes.userCoderate);
    debugReport.userFramerate = JSON.stringify(debugTypes.userFramerate);
    let delayBufferArr = debugTypes.bufferLens.sort((a, b) => a - b);
    let delayBufferArrLen = delayBufferArr.length;
    debugReport.delayBufferMin = delayBufferArr[0];
    debugReport.delayBufferMax = delayBufferArr[delayBufferArrLen - 1];
    let delayBufferAvg = 0;
    if (delayBufferArrLen > 0) {
      delayBufferAvg =
        delayBufferArr.reduce((prev, cur) => {
          return prev + cur;
        }) / delayBufferArrLen;
    }
    debugReport.delayBufferAvg = delayBufferAvg;
    debugReport.errorType = JSON.stringify(debugTypes.errorType).slice(
      0,
      50000
    );
    debugReport.catonArray = JSON.stringify(debugTypes.logCatons);
    debugReport.catonArraySum = JSON.stringify(debugTypes.stuckTimeArray);
    debugReport.lastStuckArray = JSON.stringify(debugTypes.lastStuckArray);
    let lastStuckArraySum = 0;
    for (let i = 0; i < debugTypes.lastStuckArray.length; i++) {
      lastStuckArraySum += debugTypes.lastStuckArray[i];
    }
    debugReport.isResetHls = lastStuckArraySum;

    // 上报
    reportToHive.reportDebug(debugReport);
    init();
  };

  // 每10s算一次的数据
  var reportPer = function() {
    // 计算带宽的平均值
    let bw_totalSize = 0;
    let bw_totalTime = 0;
    let bw_len = debugTypes.stats.length;
    debugTypes.stats.forEach((stat) => {
      bw_totalSize += (8 * stat.total) / 1000000; // 单位 Mb
      bw_totalTime += (stat.tbuffered - stat.trequest) / 1000; // 单位 s
    });
    if (bw_len) {
      debugTypes.userBandWidth.push((bw_totalSize / bw_totalTime).toFixed(3));
    } else {
      debugTypes.userBandWidth.push(0);
    }
    debugTypes.stats = [];

    // 计算码率的平均值
    let cr_totalSize = 0;
    let cr_totalDuration = 0;
    let cr_len = debugTypes.frags.length;
    debugTypes.frags.forEach((frag) => {
      cr_totalSize += 8 * frag.loaded;
      cr_totalDuration += frag.duration;
    });
    if (cr_len) {
      debugTypes.userCoderate.push(
        (cr_totalSize / cr_totalDuration).toFixed(3)
      );
    } else {
      debugTypes.userCoderate.push(0);
    }
    debugTypes.frags = [];

    // 计算帧率的平均值
    if (debugTypes.videoFrames && debugTypes.videoDuration) {
      debugTypes.userFramerate.push(
        Math.round(debugTypes.videoFrames / debugTypes.videoDuration)
      );
    } else {
      debugTypes.userFramerate.push(0);
    }
    debugTypes.videoFrames = 0;
    debugTypes.videoDuration = 0;
  };

  /**
   * 上报
   */
  // 统计,10s/20s计算一次，一分钟上报一次
  var debugReportCount = 0;
  setInterval(function() {
    if (debugReportCount >= 6) {
      debugReportCount = 1;
    } else {
      debugReportCount++;
    }
    reportPer();
    if (debugReportCount >= 6) {
      report();
      debugTypes.debugReportIndex += 1;
    }
    if (debugReportCount % 2) {
      debugTypes.logCatons.push(debugTypes.catonCnt);
      if (debugTypes.catonCnt > 10) {
        // 20s内大于10次卡顿
        reportToHive.reportError('caton20sOver10Times');
      }
      debugTypes.catonCnt = 0;
      debugTypes.stuckTimeArray.push(debugTypes.stuckTime);
      if (debugTypes.stuckTime > 10000) {
      }
      debugTypes.stuckTime = 0;

      // 持续卡顿记录
      if (debugTypes.isLastStuck) {
        debugTypes.lastStuckArray.push(1);
      } else {
        debugTypes.lastStuckArray.push(0);
      }
      debugTypes.isLastStuck = false;
    }
  }, 10 * 1000);

  // 卡顿
  var lastCurrentTime = 0; // 上一秒的currenttime
  var lastTimeStamp = 0; // 上一秒的时间戳
  const maxLastStuckTime = 20000; // 最大持续卡顿数，超过要重置 hls
  let lastStuckTime = 0; // 记录持续卡顿时间
  let isStuck = false;

  setInterval(function() {
    var nowTime = Date.now();
    if (videoDom && videoDom.currentTime && videoDom.currentTime > 0) {
      if (lastCurrentTime !== videoDom.currentTime) {
        if (lastCurrentTime) {
          if (isStuck) {
            debugTypes.stuckTime += nowTime - lastTimeStamp;
            debugTypes.catonCnt += 1;
            isStuck = false;
          }
        }
        lastStuckTime = 0;
        lastCurrentTime = videoDom.currentTime;
        lastTimeStamp = nowTime;
      } else {
        if (nowTime - lastTimeStamp > 200) {
          if (!videoDom.paused) {
            isStuck = true;
          }

          if (!lastStuckTime) {
            lastStuckTime = nowTime;
          }
          if (nowTime - lastStuckTime > maxLastStuckTime && !videoDom.paused) {
            if (window.TAB_ISHIDDEN) {
              lastStuckTime = 0;
              return;
            }
            // 20s持续卡顿
            reportToHive.reportError('catonOver20s');
            debugTypes.catonCnt += 1;
            debugTypes.stuckTime = 20000;
            debugTypes.isLastStuck = true;

            console.log('video-restart-log: 20s卡顿，重置播放器');
            creator && creator.reconnect();
            lastStuckTime = 0;
          }
        }
      }
    }
  }, 100);

  return {
    init: init,
    report: report,
    reportPer: reportPer
  };
};

export default debugReportToHive;
